var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[(_vm.loading)?_c('SkeletonBox',{attrs:{"width":"100%"}}):_vm._e(),(!_vm.loading)?[(_vm.icon)?_c('span',{staticClass:"overviewbox-info-item-icon"},[_c('i',{class:[_vm.iconStyle, _vm.icon]})]):_vm._e(),_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }